export class DtoGeneralCodigoNombre {
    Codigo: string = '';
    Nombre: string = '';
}